module.exports = __webpack_public_path__ + "img/ciudad-grises.122b12e9.png";